import { I18n } from '@/services/i18n';

type Message = {
  free: string;
};

const messages: I18n<Message> = {
  en: {
    free: 'free',
  },
  es: {
    free: 'gratis',
  },
  de: {
    free: 'kostenlos',
  },
};

export { messages };
